type MetaPixelEvent = 'PageView' | 'Lead' | 'ViewContent' | 'InitiateCheckout' | 'Purchase';

interface Payload {
  value?: number;
  currency?: string;
  eventId?: string;
}

export const MetaPixel = (config?: { pixelIds?: string[] }) => {
  const getInitScript = (id: string | string[]) => `!function(f,b,e,v,n,t,s)
                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window, document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');
                  ${Array.isArray(id) ? id.map((id) => `fbq('init', '${id}');`).join('\n') : `fbq('init', '${id}');`}
                  fbq('track', 'PageView');`;

  const Track = (action: 'track' | 'trackCustom', event: string, payload: Payload = {}) => {
    if (typeof window?.fbq !== 'undefined') {
      const { eventId, ...data } = payload;

      window.fbq(action, event, data, { eventID: eventId });
    }
  };

  const TrackSingle = (pixelId: string, event: MetaPixelEvent, payload?: Payload) => {
    if (typeof window?.fbq !== 'undefined') {
      const { eventId, ...data } = payload || {};

      window.fbq('trackSingle', pixelId, event, data, { eventID: eventId });
    }
  };

  const TrackCustom = (event: string, payload?: Record<string, string | number>) =>
    Track('trackCustom', event, payload);

  const _trackEvent = (event: MetaPixelEvent, payload?: Payload) => {
    if (config?.pixelIds) {
      config.pixelIds.forEach((pixelId) => {
        TrackSingle(pixelId, event, payload);
      });
    } else {
      Track('track', event, payload);
    }
  };

  const Init = (pixelId: string) => {
    if (typeof window?.fbq !== 'undefined') {
      window.fbq('init', pixelId);
    }
  };

  const PageView = (payload?: Payload) => _trackEvent('PageView', payload);

  const Lead = (payload?: Payload) => _trackEvent('Lead', payload);

  const ViewContent = (payload?: Payload) => _trackEvent('ViewContent', payload);

  const InitiateCheckout = (payload?: Payload) => _trackEvent('InitiateCheckout', payload);

  const Purchase = (payload?: Payload) => _trackEvent('Purchase', payload);

  return {
    getInitScript,
    Init,
    PageView,
    Lead,
    ViewContent,
    InitiateCheckout,
    Purchase,
    TrackCustom,
    TrackSingle,
  };
};

export default MetaPixel;
